/* eslint-disable max-len */
// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { LinkedOrderTable, OrderInformationTable } from './components/order-information-table';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { getOrderInformation, getOrderNumbers, getTransInformation } from './repositories';
import Accordion from '../../common/components/accordion';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../shared/components/labeled-input';
import LabeledReactSelect from '../../shared/components/options-drop-down/labeled-react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OrderInformation extends Component {

    state = {
        orderNumbers: [],
        selectedOrderNum: '',
        results: null
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        let queryOrderNum = query.get( 'ordernum' );
        let queryTransNumber = query.get( 'transnumber' );
        if ( this.props.order !== undefined ) {

            queryOrderNum = this.props.order ? this.props.order.trim() : this.props.order;

            queryTransNumber = this.props.transnumber;

        }
        this.props.increaseCounter();
        getOrderNumbers().then( response => {

            const newArr = response.map( item => ( { id: item, value: item } ) );
            this.setState( {
                orderNumbers: newArr
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );
        if ( queryOrderNum ) this.handleOrderNumberChange( queryOrderNum, queryTransNumber );

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryOrderNum = query.get( 'ordernum' );
            const queryTransNumber = query.get( 'transnumber' );
            this.handleOrderNumberChange( queryOrderNum, queryTransNumber );
            window.scrollTo( 0, 0 );

        }
        if ( this.props.order !== prevProps.order ) {

            if ( this.props.order !== undefined ) {

                this.handleOrderNumberChange( this.props.order ?
                    this.props.order.trim() : this.props.order, this.props.transnumber );

            }

        }

    }

    handleSelectOrderNumberChange ( orderNumber ) {

        this.handleOrderNumberChange( orderNumber.value );

    }

    handleOrderNumberChange ( orderNumber, transNumber ) {

        if ( orderNumber === '-1' ) {

            this.setState( {
                selectedOrderNum: '',
                results: null
            } );

        } else {

            this.setState( {
                selectedOrderNum: orderNumber
            } );

            this.props.increaseCounter();
            if ( transNumber ) {

                getTransInformation( orderNumber, transNumber )
                    .then( response => {

                        this.setState( {
                            results: response
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

            } else {

                getOrderInformation( orderNumber )
                    .then( response => {

                        this.setState( {
                            results: response
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

            }

        }

    }

    getDateFormat = givenDate => ( formatGivenDate( givenDate, 'YYYY-MM-DD' ) );

    refresh () {

        this.handleOrderNumberChange( this.state.selectedOrderNum );

    }

    render () {

        const {
            orderNumbers, selectedOrderNum, results
        } = this.state;

        const additionalInfo = ( results !== null ? {
            reportType: results.reportType,
            tempCountingBundle: results.tempCountingBundle,
            unitName: this.props.unit.name
        } : '' );
        const fullResults = ( results !== null && results.orderCodes !== null ?
            [...results.orderCodes] : [] );
        const orderCodeResult = fullResults !== null ?
            fullResults.map( i => ( { ...i, ...additionalInfo } ) ) : [];

        const linkedOrders = ( results !== null && results.linkedOrders ?
            [...results.linkedOrders] : [] );
        const linkedOrdersResult = linkedOrders !== null ? linkedOrders.map( i => (
            { ...i, ...{ unitName: this.props.unit.name } } ) ) : [];
        const searchableOrderNumber = orderNumbers.map( item => ( {
            label: item.id.trim(),
            value: item.value.trim()
        } ) );
        const searchableSelectedOrderNumber = selectedOrderNum === '' ? null : ( {
            label: selectedOrderNum,
            value: selectedOrderNum
        } );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header"> Order Information </h2>
                </header>
                <main>
                    <section className="section-container">
                        {this.props.order === undefined && (
                            <div className="atp-order-information-top-options">
                                <div className="select-options">
                                    <LabeledReactSelect
                                        className="atp-order-information-select"
                                        label="Order Number"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleSelectOrderNumberChange.bind( this )}
                                        options={searchableOrderNumber}
                                        placeholder="Select Order Number"
                                        selectedValue={searchableSelectedOrderNumber}
                                    />
                                    {selectedOrderNum && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                                </div>
                            </div>
                        )}
                        {( results !== null && results.general === null && ( selectedOrderNum !== '' || this.props.order !== undefined ) ) ? (
                            <div>
                                Order Number not Found
                            </div>
                        ) : (
                            <div className="order-information-results">
                                <div className="order-information-sections">
                                    {this.props.order && results !== null && results.transaction !== null && (
                                        <Accordion
                                            accordionId="order-information-transaction"
                                            title="Transaction"
                                            isExpanded={true}
                                        >
                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="date"
                                                isEditable={false}
                                                label="Date"
                                                value={this.getDateFormat( results.transaction.date )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="time"
                                                isEditable={false}
                                                label="Time"
                                                value={results.transaction.time}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="orginalBuidWeek"
                                                isEditable={false}
                                                label="Orig Bld Wk"
                                                value={this.getDateFormat( results.transaction.orginalBuidWeek )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="activity"
                                                isEditable={false}
                                                label="Activity"
                                                value={results.transaction.activity}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="drc"
                                                isEditable={false}
                                                label="DRC"
                                                value={results.transaction.drc}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="frc"
                                                isEditable={false}
                                                label="FRC"
                                                value={results.transaction.frc}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="expWhse"
                                                isEditable={false}
                                                label="Exp Whse"
                                                value={this.getDateFormat( results.transaction.expWhse )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="error"
                                                isEditable={false}
                                                label="Error"
                                                value={results.transaction.error}
                                            />
                                        </Accordion>

                                    )}
                                    {results !== null && results.general !== null && (
                                        <Accordion
                                            accordionId="order-information-general"
                                            title="General"
                                            isExpanded={true}
                                        >

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="order"
                                                isEditable={false}
                                                label="Order"
                                                link={`/${this.props.unit.name}/order/transaction-log?ordernumber=${results.general.orderNumber}`}
                                                value={results.general.orderNumber}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="entered"
                                                isEditable={false}
                                                label="Entered"
                                                value={this.getDateFormat( this.props.order ? results.general.entered : results.general.orderEntryDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="retailInd"
                                                isEditable={false}
                                                label="Retail Ind"
                                                value={results.general.retailIndicator}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="buildWeek"
                                                isEditable={false}
                                                label="Build Wk"
                                                value={this.getDateFormat( results.general.buildWeek )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="requestedDeliveryDate"
                                                isEditable={false}
                                                label="RDD"
                                                value={this.getDateFormat( this.props.order ? results.general.rdd : results.general.reqDeliveryDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="factDeliveryDate"
                                                isEditable={false}
                                                label="FDD"
                                                value={this.getDateFormat( this.props.order ? results.general.fdd : results.general.factDeliveryDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="prefCustOrder"
                                                isEditable={false}
                                                label="Pref Cust Order"
                                                value={this.props.order ? results.general.prefCustOrder : results.general.preferredCustOrder}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="salesPgm"
                                                isEditable={false}
                                                label="Sales Pgm"
                                                value={results.general.salesProgram}
                                            />
                                            { !this.props.order && (
                                                <>
                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="qty"
                                                        isEditable={false}
                                                        label="Qty"
                                                        value={results.general.qtyCount}
                                                    />

                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="prodOrder"
                                                        isEditable={false}
                                                        label="Prod Order"
                                                        value={results.general.prodOrderNumber}
                                                    />

                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="prodStatus"
                                                        isEditable={false}
                                                        label="Prod Status"
                                                        value={results.general.prodStatus}
                                                    />
                                                </>
                                            )}
                                            { this.props.order && (
                                                <LabeledInput
                                                    className="order-information-labeled-input"
                                                    name="expWarehouse"
                                                    isEditable={false}
                                                    label="Exp Whse"
                                                    value={this.getDateFormat( results.general.expWarehouse )}
                                                />

                                            )}

                                        </Accordion>
                                    )}
                                    {results !== null && results.configuration !== null && (
                                        <Accordion
                                            accordionId="order-information-configuration"
                                            title="Configuration"
                                            isExpanded={true}
                                        >

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="family"
                                                isEditable={false}
                                                label="Family"
                                                value={results.configuration.effectiveFamily}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="model"
                                                isEditable={false}
                                                label="Model"
                                                value={results.configuration.model}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="base"
                                                isEditable={false}
                                                label="Base"
                                                value={results.configuration.baseMachine}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="poolPkgCode"
                                                isEditable={false}
                                                label="Pool Pkg Code"
                                                value={results.configuration.poolPkgCode}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="poolOrderNo"
                                                isEditable={false}
                                                label="Pool Order No"
                                                value={results.configuration.poolOrderNo}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="status"
                                                isEditable={false}
                                                label="Status"
                                                value={results.configuration.orderStatus}
                                            />

                                        </Accordion>
                                    )}
                                    {results !== null && results.shipping !== null && (
                                        <Accordion
                                            accordionId="order-information-shipping"
                                            title="Shipping"
                                            isExpanded={true}
                                        >

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="earlyInd"
                                                isEditable={false}
                                                label="Early Ind"
                                                value={results.shipping.earlyShipInd}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="mode"
                                                isEditable={false}
                                                label="Mode"
                                                value={results.shipping.shippingMode}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="suc"
                                                isEditable={false}
                                                label="SUC"
                                                value={this.getDateFormat( results.shipping.shipUnitCtlDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="offsetWks"
                                                isEditable={false}
                                                label="OffSet Wks"
                                                value={results.shipping.offsetWeeks}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="setUpDays"
                                                isEditable={false}
                                                label="Setup Days"
                                                value={results.shipping.shipperSetupDays}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="transDays"
                                                isEditable={false}
                                                label="Trans Days"
                                                value={results.shipping.transportDays}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="landDays"
                                                isEditable={false}
                                                label="Land Days"
                                                value={results.shipping.landDays}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="oceanDays"
                                                isEditable={false}
                                                label="Ocean Days"
                                                value={results.shipping.oceanDays}
                                            />

                                        </Accordion>
                                    )}
                                    {results !== null && results.linkedOrders !== null && (
                                        <Accordion
                                            accordionId="order-information-linkedOrders"
                                            title="Linked Orders"
                                            isExpanded={true}
                                        >
                                            {( linkedOrdersResult.length > 0 ? (
                                                <LinkedOrderTable
                                                    results={linkedOrdersResult}
                                                    transactionField={this.props.order}
                                                />
                                            ) : 'There are no linked orders' )}
                                        </Accordion>
                                    )}
                                    {results !== null && results.otherFields !== null && (
                                        <Accordion
                                            accordionId="order-information-otherFields"
                                            title="Other Fields"
                                            isExpanded={false}
                                        >

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="custOrder"
                                                isEditable={false}
                                                label="Cust Order"
                                                value={this.props.order ? results.otherFields.custOrder : results.otherFields.custOrderNumber}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="orderKind"
                                                isEditable={false}
                                                label="Order Kind"
                                                value={results.otherFields.orderKind}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="soldTo"
                                                isEditable={false}
                                                label="Sold To"
                                                value={this.props.order ? results.otherFields.soldto : results.otherFields.soldToAccount}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="pinnedInd"
                                                isEditable={false}
                                                label="Pinned Ind"
                                                value={this.props.order ? results.otherFields.pinnedInd : results.otherFields.pinnedOrderInd}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="creditCode"
                                                isEditable={false}
                                                label="Credit Code"
                                                value={results.otherFields.creditCode}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="ccgEarliest"
                                                isEditable={false}
                                                label="CCG Earliest"
                                                value={this.getDateFormat( this.props.order ? results.otherFields.ccgEarlierDate : results.otherFields.ccgBeginEffDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="ccgLatest"
                                                isEditable={false}
                                                label="CCG Latest"
                                                value={this.getDateFormat( this.props.order ? results.otherFields.ccgLatestDate : results.otherFields.ccgEndEffDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="initConfig"
                                                isEditable={false}
                                                label="Init Config"
                                                value={this.getDateFormat( results.otherFields.initConfigDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="currConfig"
                                                isEditable={false}
                                                label="Curr Config"
                                                value={this.getDateFormat( this.props.order ? results.otherFields.currconfigure : results.otherFields.currConfigDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="lineupDate"
                                                isEditable={false}
                                                label="Lineup Date"
                                                value={this.getDateFormat( this.props.order ? results.otherFields.lineupDate : results.otherFields.factLineupDate )}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="rrdVsOcd"
                                                isEditable={false}
                                                label="RDD vs OCD"
                                                value={this.props.order ? results.otherFields.rddvsOcd : results.otherFields.totatlRddOcdDays}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="allocated"
                                                isEditable={false}
                                                label="Allocated"
                                                value={this.props.order ? results.otherFields.allocated : results.otherFields.allocatedInd}
                                            />

                                            <LabeledInput
                                                className="order-information-labeled-input"
                                                name="freeze"
                                                isEditable={false}
                                                label="Freeze"
                                                value={this.props.order ? results.otherFields.freeze : results.otherFields.freezeFlag}
                                            />
                                            { !this.props.order && (
                                                <LabeledInput
                                                    className="order-information-labeled-input"
                                                    name="ltl"
                                                    isEditable={false}
                                                    label="LTL"
                                                    value={results.otherFields.ltlIndicator}
                                                />
                                            )}
                                            { this.props.order && (
                                                <>
                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="fmlyOneCode"
                                                        isEditable={false}
                                                        label="Fmly 1 Code"
                                                        value={results.otherFields.fmlyOneCode}
                                                    />
                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="fmlyOneBegn"
                                                        isEditable={false}
                                                        label="Fmly 1 begin"
                                                        value={this.getDateFormat( results.otherFields.fmlyOneBegn )}
                                                    />
                                                    <LabeledInput
                                                        className="order-information-labeled-input"
                                                        name="fmlyOneEnd"
                                                        isEditable={false}
                                                        label="Fmly 1 End"
                                                        value={this.getDateFormat( results.otherFields.fmlyOneEnd )}
                                                    />

                                                </>
                                            )}

                                        </Accordion>
                                    )}
                                </div>
                                <div className="order-information-table-section">
                                    {results !== null && results.orderCodes !== null && (
                                        <Accordion
                                            accordionId="order-information-orderCodes"
                                            title="Order Codes"
                                            isExpanded={true}
                                        >
                                            <OrderInformationTable
                                                results={orderCodeResult}
                                                transactionField={this.props.order}
                                            />
                                        </Accordion>
                                    )}
                                </div>

                            </div>
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OrderInformation.displayName = 'OrderInformation';
OrderInformation.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    order: PropTypes.string,
    transnumber: PropTypes.string
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OrderInformation ) );
